import { defineComponent as _defineComponent } from 'vue'
import { Vue } from 'vue-property-decorator'
import { ref, watch, onMounted } from 'vue'
import { ColorPickerPlugin } from '@syncfusion/ej2-vue-inputs'
import { useAttrs } from '@/composables/useAttrs'


export default /*#__PURE__*/_defineComponent({
  __name: 'LexonColorPickerComponent',
  props: {
  defaultValue: {
    type: String,
    default: '#001978'
  }
},
  emits: ['input'],
  setup(__props, { emit }) {

const props = __props;

Vue.use(ColorPickerPlugin)



// DATA


const color = ref('')

// COMPOSABLES
const { attrsValue } = useAttrs()

const rendereColor = () => {
  if (attrsValue) {
    color.value = attrsValue
  } else {
    color.value = props.defaultValue
  }
}

onMounted(rendereColor)

watch(color, (newValue) => {
  emit('input', newValue)
})

return { __sfc: true,emit, props, color, attrsValue, rendereColor, Vue, ref, watch, onMounted, ColorPickerPlugin, useAttrs }
}

})